import { render, staticRenderFns } from "./ProcessPayroll.vue?vue&type=template&id=607da9ff&scoped=true"
import script from "./ProcessPayroll.vue?vue&type=script&lang=js"
export * from "./ProcessPayroll.vue?vue&type=script&lang=js"
import style0 from "./ProcessPayroll.vue?vue&type=style&index=0&id=607da9ff&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607da9ff",
  null
  
)

export default component.exports